import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PDFViewerState {
  isOpen: boolean;
  pdfUrl: string | null;
  reportName: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: PDFViewerState = {
  isOpen: false,
  pdfUrl: null,
  reportName: null,
  loading: false,
  error: null,
};

const pdfViewerSlice = createSlice({
  name: "pdfViewer",
  initialState,
  reducers: {
    openPDFViewer: (
      state,
      action: PayloadAction<{ pdfUrl: string; reportName: string }>
    ) => {
      state.isOpen = true;
      state.pdfUrl = action.payload.pdfUrl;
      state.reportName = action.payload.reportName;
      state.loading = false;
      state.error = null;
    },
    closePDFViewer: (state) => {
      // Clean up blob URL if it exists
      if (state.pdfUrl && state.pdfUrl.startsWith("blob:")) {
        window.URL.revokeObjectURL(state.pdfUrl);
      }
      state.isOpen = false;
      state.pdfUrl = null;
      state.reportName = null;
      state.loading = false;
      state.error = null;
    },
    setPDFViewerLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPDFViewerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  openPDFViewer,
  closePDFViewer,
  setPDFViewerLoading,
  setPDFViewerError,
} = pdfViewerSlice.actions;

export default pdfViewerSlice.reducer;

